import React, { useEffect, useState } from 'react';
import { ArmGlobalNavigation } from '@arm/ce-shared-components';
import config from '../../../temp/config';
import './GlobalNavigation.css';
import { UseGlobalState } from '../../../context';
import { initAzureB2CAction } from '../../../context/action/user';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const GlobalNavigation = ({ fields, rendering, sitecoreContext }) => {
  const isEditorMode = sitecoreContext?.pageEditing;
  const { dispatch, user } = UseGlobalState();

  useEffect(() => {
    if (isEditorMode) {
      return null;
    }
    initAzureB2CAction(dispatch);
  }, [dispatch]);

  return (
    <ArmGlobalNavigation
      appName={`developer`}
      auth={{
        user: user?.user,
        menuLinks: [
          {
            label: 'Profile',
            url: config.REACT_APP_SITECORE_PROFILE_LINK,
          },
          {
            label: 'Settings',
            url: config.REACT_APP_SITECORE_SETTINGS_LINK,
          },
          {
            label: 'Notifications',
            url: config.REACT_APP_SITECORE_NOTIFICATIONS_LINK,
          },
        ],
        loginLink:
          config.REACT_APP_ORIGIN +
          config.REACT_APP_PATHNAME +
          `user-login${
            typeof window === 'undefined' ? '' : '?returnUrl=' + window.location.pathname
          }`,
        logoutLink: config.REACT_APP_ORIGIN + config.REACT_APP_PATHNAME + 'user-logout',
        notificationsApi: config.REACT_APP_SITECORE_NOTIFICATIONS_API,
        registerLink: '/register',
      }}
      searchUrl={`${config.REACT_APP_ORIGIN}/search#numberOfResults=48&q=`}
      isTheme={false}
      scriptEnvironmentHostUrl={config.REACT_APP_ARM_GLOBALNAVIGATION_HOST}
    />
  );
};
const GlobalNavigationClient = () => {
  return (
    <ArmGlobalNavigation
      appName={`developer`}
      auth={{
        menuLinks: [
          {
            label: 'Profile',
            url: config.REACT_APP_SITECORE_PROFILE_LINK,
          },
          {
            label: 'Settings',
            url: config.REACT_APP_SITECORE_SETTINGS_LINK,
          },
          {
            label: 'Notifications',
            url: config.REACT_APP_SITECORE_NOTIFICATIONS_LINK,
          },
        ],
        loginLink: `user-login?returnUrl=${window.location.pathname}`,
        registerLink: '/register',
        logoutLink: '/user-logout',
      }}
      searchUrl={`${config.REACT_APP_ORIGIN}/search#numberOfResults=48&q=`}
      isTheme={false}
      scriptEnvironmentHostUrl={config.REACT_APP_ARM_GLOBALNAVIGATION_HOST}
    />
  );
};

export default withSitecoreContext()(GlobalNavigation);
export { GlobalNavigationClient };
